var render = function render(){var _vm=this,_c=_vm._self._c;return _c('currentUser',{scopedSlots:_vm._u([{key:"default",fn:function(slotProps){return [_vm._v(" "+_vm._s(slotProps.user.firstName)+" ")]}},{key:"test",fn:function({ user }){return [_vm._v(" "+_vm._s(user)+" ")]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }